import { render, staticRenderFns } from "./OccupancyGroupCard.vue?vue&type=template&id=22f100d9&"
import script from "./OccupancyGroupCard.vue?vue&type=script&lang=js&"
export * from "./OccupancyGroupCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports